const _toString = Object.prototype.toString

function isRegExp(v) {
  return _toString.call(v) === '[object RegExp]'
}

//type VNodeCache = {};
function isDef(v) {
  return v !== undefined && v !== null
}

function getFirstComponentChild(children) {
  if (Array.isArray(children)) {
    for (let i = 0; i < children.length; i++) {
      const c = children[i]
      if (isDef(c) && isDef(c.componentOptions)) {
        return c
      }
    }
  }
}


const patternTypes = [String, RegExp, Array]

function getComponentName(opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches(pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache(cache, current, filter) {
  for (const key in cache) {
    const cachedNode = cache[key]
    if (cachedNode) {
      const name = key; // getComponentName(cachedNode.componentOptions)
      if (name && !filter(name)) {
        if (cachedNode !== current) {
          pruneCacheEntry(cachedNode)
        }
        // console.log("-------" + key);
        cache[key] = null
      }
    }
  }
}

function pruneCacheEntry(vnode) {
  if (vnode) {
    vnode.componentInstance.$destroy()
    vnode.keepAlive = false;
  }
}

function GetDefaultComponentName(to) {
  return _.last(to.matched).components.default.name;
}

export default {
  name: 'm-keepalive',
  data() {
    return {
      historys: []
    }
  },
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes
  },

  created() {
    this.cache = Object.create(null)
    //window.__cache = this.cache;
    //window.__historys = this.historys;
    // console.log("m-keepalive created");
  },

  destroyed() {
    for (const key in this.cache) {
      pruneCacheEntry(this.cache[key])
    }
  },
  mounted() {
    if (this.historys.length == 0) {
      this.historys.push({
        path: '/',
        name: 'root',
        fullPath: '/'
      });
      var path = this.$route.path;
      if (this.$route.matched.length <= 0) {
        return
      }

      var name = GetDefaultComponentName(this.$route);
      var __route = this.$route;
      this.historys.push({
        path: path,
        name: name,
        fullPath: __route.fullPath
      });
    }
  },

  watch: {
    include(val) {
      // pruneCache(this.cache, this._vnode, name => matches(val, name))
    },
    exclude(val) {
      // pruneCache(this.cache, this._vnode, name => !matches(val, name))
    },
    '$route'(to, from) {
      let historys = this.historys;
      let last = _.last(historys);
      if (last.fullPath == to.fullPath)
        return;

      let name = GetDefaultComponentName(to);
      var historyCount = historys.length;
      // _.remove(historys, h => {
      //   return h.name == name && h.fullPath == to.fullPath;
      // });
      // var keepAlive = historys.map(function (router) {
      //   return (router.name || router.path).replace('/', '');
      // }).join(',');

      var keepAlive = historys.map(function (router) {
        return router.fullPath.replace(/[^\w|\d]/gi, '');
      }).join(',');


      if (historys.length != historyCount) {
        pruneCache(this.cache, this._vnode, name => matches(keepAlive, name))
      }

      var isBack = historys.length >= 2 && to.fullPath == _.first(_.takeRight(historys, 2)).fullPath;
      let isReplace = historys.length == 2 && _.startsWith(from.fullPath, to.fullPath);
      if (isBack || isReplace) {
        historys.pop();
      }

      if (!isBack || isReplace) {
        historys.push({
          path: to.path,
          name: name,
          fullPath: to.fullPath
        });
      }
      keepAlive = historys.map(function (router) {
        return router.fullPath.replace(/[^\w|\d]/gi, '');
      }).join(',');
      if (to.fullPath == "/" || to.fullPath == "") {
        pruneCache(this.cache, this._vnode, name => name=="")
        // for (const key in this.cache) {
        //   const cachedNode = this.cache[key]
        //   if (cachedNode) {
        //     pruneCacheEntry(cachedNode)
        //   }
        //   this.cache[key] = null
        // }
      } else {
        pruneCache(this.cache, this._vnode, name => matches(keepAlive, name))
      }
    },
  },

  render() {
    // console.log("reader keep - alive")
    const vnode = getFirstComponentChild(this.$slots.default)
    const componentOptions = vnode && vnode.componentOptions
    if (componentOptions) {
      // check pattern
      const name = getComponentName(componentOptions)
      if (name && (
          (this.include && !matches(this.include, name)) ||
          (this.exclude && matches(this.exclude, name))
        )) {
        return vnode
      }
      // const key = vnode.key == null
      //   // same constructor may get registered as different local components
      //   // so cid alone is not enough (#3269)
      //   ?
      //   componentOptions.Ctor.cid + (componentOptions.tag ? `::${componentOptions.tag}` : '') :
      //   vnode.key
      let key = this.$route.fullPath.replace(/[^\w|\d]/gi, '');
      if (this.cache[key]) {
        vnode.componentInstance = this.cache[key].componentInstance
      } else {
        this.cache[key] = vnode
      }
      vnode.data.keepAlive = true
    }
    return vnode
  }
}



// WEBPACK FOOTER //
// ./src/views/modules/keep-alive.js